import { render } from "./OverlayLoading.vue?vue&type=template&id=089ca4d6"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__